window.RecommendationAPI = new (function () {
  var self = this;
  var _protected = BaseAPI.call(self);

  var RECOMMENDED_JOBS_LIMIT = 4;

  self.loadJobs = function (limit, location, positions, hecs, categories, ignoredJobsList) {

    var deferred = $q.defer();

    limit = limit || RECOMMENDED_JOBS_LIMIT;
    location = location || [];
    positions = positions || [];
    hecs = hecs || [];
    categories = categories || [];

    categories = categories[0]? categories: ["Front of House"];

    var promises = [];
    var index = 0;

    var DEFAULT_SEARCH_OBJECT = {
      "search_phrase": "",
      "start": 0,
      "size": limit,
      "ignore_my_jobs": 1,
      "radius": 30,
      "positions": [],
      "categories": [],
      "sort": ["publish_date"],
      "hecs": [],
      "locations": []
    };

    var extendedSearchObject = $.extend({},DEFAULT_SEARCH_OBJECT);


    if( ignoredJobsList && ignoredJobsList.length ){
      extendedSearchObject['ignore_list'] = ignoredJobsList;
    }

    if (hecs.length) {
      var search_options_0 = $.extend({}, extendedSearchObject);
      search_options_0['positions'] = positions;
      search_options_0['hecs'] = hecs;
      search_options_0['locations'] = location;


      promises[index++] = _protected.request('harri_search/search_recommended_jobs', 'POST', search_options_0);
    }


    if (positions.length) {
      var search_options_1 = $.extend({}, extendedSearchObject);
      search_options_1['positions'] = positions;
      search_options_1['locations'] = location;

      promises[index++] = _protected.request('harri_search/search_recommended_jobs', 'POST', search_options_1);
    }

    var search_options_2 = $.extend({}, extendedSearchObject);
    search_options_2['categories'] = categories;
    search_options_2['locations'] = location;

    promises[index++] = _protected.request('harri_search/search_recommended_jobs', 'POST', search_options_2);

    $q.all(promises).then(function (res) {

      var JOBS_TO_SHOW = limit;

      var jobs = [];
      var jobsIds = [];

      for (var group in res) {
        var loadedJobs = (res[group] && res[group].data && res[group].data.data && res[group].data.data.results) || [];

        for (var i in loadedJobs) {
          var job = loadedJobs[i];

          if (jobsIds.indexOf(job.id) == -1) {
            jobs.push(job);
            jobsIds.push(job.id);
          }

          if (jobs.length == JOBS_TO_SHOW) {
            deferred.resolve(jobs);
            return;
          }
        }
      }

      deferred.resolve(jobs);
    });

    return deferred.promise;
  }

  self.loadJobsFromSameBrand = async function (limit, location, categories, ignoredJobsList, brandId){

      let payload = {
          "size": limit,
          "radius": 50,
          "locations": location,
          "sort": ["distance"],
          "categories": categories,
          "postal_code_raduis": 50
      };

      if (brandId) {
          payload['brand_level_ids'] = [brandId];
      }

      if (ignoredJobsList && ignoredJobsList.length) {
          payload['ignore_list'] = ignoredJobsList;
      }

      let response = await _protected.request('harri_search/search_jobs', 'POST', payload);

      if (response.status !== 200) {
          throw (response);
      }

      return response.data.data;
  };
});
